import React from "react";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import { useWishlist } from "../context/WishlistContext";

// Floating heart toggle for any product card/image. Renders nothing when the
// wishlist module is off for this store. Place inside a position:relative parent.
export default function WishlistHeart({ productId, style }) {
  const { enabled, isWishlisted, toggle } = useWishlist();
  if (!enabled) return null;

  return (
    <button
      type="button"
      aria-label="Save to wishlist"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(productId); }}
      style={{
        position: "absolute", top: 8, right: 8, width: 34, height: 34, borderRadius: "50%",
        border: "none", background: "rgba(255,255,255,0.92)", boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
        display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer",
        color: "#444", fontSize: 15, zIndex: 3, ...style,
      }}
    >
      {isWishlisted(productId) ? <FaHeart color="#e0245e" /> : <FaRegHeart />}
    </button>
  );
}
